import { SystemStyleObject } from '@styled-system/css';

const wrapperStyle: SystemStyleObject = {
  width: '792px',
  '& > .fr-box': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 0,
  },
  '& .fr-wrapper': {
    flexGrow: 1,
    borderBottom: '1px solid #CCCCCC !important',
    '& hr': {
      border: 0,
      borderTop: '1px solid rgba(0,0,0,0.1)',
    },
  },
  '& .fr-toolbar': {
    backgroundColor: '#f5f5f5',
    display: 'grid',
    gridTemplateColumns: '1fr 108px',
    borderRadius: 0,
    '.fr-btn-grp': {
      mr: 0,
      ml: 0,
      pl: 4,
      backgroundColor: 'white',
    },
    '.fr-more-toolbar': {
      pl: '8px !important',
    },
    '#moreMisc-1': {
      display: 'none',
    },
    borderBottom: '1px solid #efefef',
    '.fr-newline': {
      display: 'none',
    },
  },
  '& .fr-second-toolbar': {
    display: 'none',
  },
  // 참고: https://wysiwyg-editor.froala.help/hc/en-us/articles/115000817105-How-can-I-set-a-default-font-style-
  '& .fr-box.fr-basic .fr-element.fr-view': {
    wordBreak: 'normal',
    padding: '77px',
    fontFamily: 'Noto Sans CJK KR Subset',
    color: '#000000',
    letterSpacing: '0',
    // normalize 제거
    'ol, ul': {
      listStyleType: 'unset',
      marginBottom: '1em',
      paddingLeft: '40px',
    },
    ol: {
      listStyleType: 'decimal',
    },
    ul: {
      listStyleType: 'disc',
    },
    'ol > li': {
      listStyleType: 'unset',
    },
    'ul > li': {
      listStyleType: 'unset',
    },
    p: {
      lineHeight: 'unset',
    },
  },
};

export default wrapperStyle;
